(function() {
  'use strict';

  if (!window.theme) return;

  function patchCartFormForOoDrawer() {
    if (!theme.CartForm || theme.CartForm._ooCartFormPatched) return;

    var originalInit = theme.CartForm.prototype.init;
    var originalInitQtySelectors = theme.CartForm.prototype.initQtySelectors;
    var originalQuantityChanged = theme.CartForm.prototype.quantityChanged;

    theme.CartForm.prototype.initQtySelectors = function() {
      if (this.location === 'oo-cart-drawer') return;
      return originalInitQtySelectors.call(this);
    };

    theme.CartForm.prototype.quantityChanged = function(evt) {
      if (this.location === 'oo-cart-drawer') return;
      return originalQuantityChanged.call(this, evt);
    };

    theme.CartForm.prototype.init = function() {
      if (this.location === 'oo-cart-drawer') {
        this.initQtySelectors();

        this.form.on('submit' + this.namespace, this.onSubmit.bind(this));

        if (this.noteInput) {
          this.noteInput.addEventListener('change', function() {
            var newNote = this.value;
            theme.cart.updateNote(newNote);
          });
        }

        return;
      }

      return originalInit.call(this);
    };

    theme.CartForm._ooCartFormPatched = true;
  }

  function getStrikethroughUnitFromRow(row) {
    if (!row) return 0;

    var strikethroughUnit = parseInt(row.dataset.strikethroughUnitCents, 10) || 0;
    if (strikethroughUnit > 0) return strikethroughUnit;

    return parseInt(row.dataset.compareAtUnitCents, 10) || 0;
  }

  function getStrikethroughLineTotal(item, row) {
    var finalLine = item.final_line_price != null ? item.final_line_price : item.line_price;
    var finalPrice = item.final_price != null ? item.final_price : item.price;
    var qty = item.quantity;

    if (row) {
      var strikethroughLineFromDataset = parseInt(row.dataset.strikethroughLineCents, 10) || 0;
      if (strikethroughLineFromDataset > finalLine) return strikethroughLineFromDataset;

      var strikethroughUnitFromRow = getStrikethroughUnitFromRow(row);
      if (strikethroughUnitFromRow > 0) {
        var strikethroughLineFromRow = strikethroughUnitFromRow * qty;
        if (strikethroughLineFromRow > finalLine) return strikethroughLineFromRow;
      }
    }

    var compareAt = item.compare_at_price;
    if (!compareAt && item.variant) {
      compareAt = item.variant.compare_at_price;
    }

    if (compareAt && compareAt > finalPrice) {
      var compareAtLine = compareAt * qty;
      if (compareAtLine > finalLine) return compareAtLine;
    }

    if (item.original_line_price > finalLine) return item.original_line_price;

    var linePrice = item.line_price;
    if (linePrice > finalLine) return linePrice;

    return finalLine;
  }

  function getStrikethroughSubtotal(cart, findRow) {
    if (!cart || !cart.items) return 0;

    var usedRows = [];

    return cart.items.reduce(function(sum, item) {
      var row = findRow ? findRow(item, usedRows) : null;
      if (row) usedRows.push(row);
      return sum + getStrikethroughLineTotal(item, row);
    }, 0);
  }

  function getStrikethroughLineCentsFromRow(row) {
    if (!row) return 0;

    var linePrice = parseInt(row.dataset.linePriceCents, 10) || 0;
    var strikethroughLine = parseInt(row.dataset.strikethroughLineCents, 10) || 0;

    if (strikethroughLine > linePrice) return strikethroughLine;

    var qty = parseInt(row.querySelector('.js-qty__num') && row.querySelector('.js-qty__num').value, 10) || 1;
    var strikethroughUnit = getStrikethroughUnitFromRow(row);

    if (strikethroughUnit > 0) {
      strikethroughLine = strikethroughUnit * qty;
      if (strikethroughLine > linePrice) return strikethroughLine;
    }

    var originalEl = row.querySelector('[data-line-price-original]');
    if (originalEl && !originalEl.hasAttribute('hidden')) {
      var originalText = (originalEl.textContent || '').trim();
      if (originalText) {
        var numeric = originalText.replace(/[^\d,.-]/g, '');
        if (numeric.indexOf(',') !== -1 && numeric.indexOf('.') !== -1) {
          numeric = numeric.replace(/\./g, '').replace(',', '.');
        } else if (numeric.indexOf(',') !== -1) {
          numeric = numeric.replace(',', '.');
        }

        var parsed = Math.round(parseFloat(numeric) * 100);
        if (!isNaN(parsed) && parsed > linePrice) return parsed;
      }
    }

    return linePrice;
  }

  function getStrikethroughSubtotalFromDom(form) {
    if (!form) return 0;

    var total = 0;

    form.querySelectorAll('.oo-cart-item[data-key]').forEach(function(row) {
      total += getStrikethroughLineCentsFromRow(row);
    });

    return total;
  }

  theme.OoCartDrawer = (function() {
    function OoCartDrawer() {
      this.form = document.getElementById('OoCartDrawerForm');
      if (!this.form) return;

      patchCartFormForOoDrawer();

      this.drawer = new theme.Drawers('OoCartDrawer', 'oo-cart');
      this.cartForm = new theme.CartForm(this.form);
      this.productsContainer = this.form.querySelector('[data-products]');
      this.upsellContainer = this.form.querySelector('[data-oo-upsell-container]');
      this.shippingBlock = this.form.querySelector('[data-oo-shipping]');
      this.shippingText = this.form.querySelector('[data-oo-shipping-text]');
      this.shippingProgress = this.form.querySelector('[data-oo-shipping-progress]');
      this.subtotalOriginal = this.form.querySelector('[data-oo-subtotal-original]');
      this.footer = this.form.querySelector('[data-oo-footer]');
      this.emptyState = this.form.querySelector('[data-oo-empty]');
      this.body = this.form.querySelector('.oo-cart-drawer__body');
      this.noticeEl = this.form.querySelector('[data-oo-notice]');
      this._lastCartJsonApply = 0;
      this._cartBuildTimer = null;

      this.patchCartForm();
      this.bindEvents();
      this.cartForm.buildCart();
      this.initUpsellControls();
    }

    OoCartDrawer.prototype.patchCartForm = function() {
      var self = this;

      this.cartForm.buildCart = function() {
        return theme.cart.getCart()
          .then(function(cart) {
            if (!self.needsProductMarkupRefresh(cart)) {
              self.applyCartJson(cart);
              return self.refreshUpsellFromAjax();
            }

            var url = theme.routes.cartPage + '?view=oo-ajax&t=' + Date.now();
            return fetch(url, { credentials: 'same-origin', method: 'GET' })
              .then(function(response) { return response.text(); })
              .then(self.cartForm.cartMarkup.bind(self.cartForm));
          })
          .catch(function(e) { console.error(e); });
      }.bind(this.cartForm);

      this.cartForm._parseProductHTML = function(text) {
        var html = document.createElement('div');
        html.innerHTML = text;

        return {
          items: html.querySelector('.cart__items'),
          discounts: html.querySelector('.cart__discounts'),
          upsell: html.querySelector('[data-oo-upsell]')
        };
      };

      this.cartForm.updateCartDiscounts = function(markup) {
        if (!this.discounts) return;
        this.discounts.innerHTML = '';
        if (markup) {
          this.discounts.append(markup);
        }
      };

      this.cartForm.cartMarkup = function(text) {
        var markup = this._parseProductHTML(text);
        var items = markup.items;

        if (!items) {
          console.error('OO cart drawer: could not parse cart markup');
          return;
        }

        var count = parseInt(items.dataset.count, 10) || 0;
        var subtotal = items.dataset.cartSubtotal;
        var originalSubtotal = items.dataset.cartOriginalSubtotal;

        this.updateCartDiscounts(markup.discounts);
        self.updateShippingBar(items);
        self.updateUpsell(markup.upsell);
        self.updateEmptyState(count);

        this.updateCount(count);
        this.products.innerHTML = '';
        this.products.append(items);

        if (this.subtotal) {
          this.subtotal.innerHTML = theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);
        }

        self.updateSubtotalDisplay(subtotal, originalSubtotal);
        this.reInit();

        if (window.AOS) AOS.refreshHard();
        if (Shopify && Shopify.StorefrontExpressButtons) {
          Shopify.StorefrontExpressButtons.initialize();
        }

        document.dispatchEvent(new CustomEvent('cart:updated'));
      }.bind(this.cartForm);
    };

    OoCartDrawer.prototype.updateShippingBar = function(items) {
      if (!this.shippingBlock) return;

      var remaining = parseInt(items.dataset.freeShippingRemaining, 10) || 0;
      var progress = parseInt(items.dataset.freeShippingProgress, 10) || 0;
      var count = parseInt(items.dataset.count, 10) || 0;

      if (count === 0) {
        this.shippingBlock.setAttribute('hidden', '');
        return;
      }

      this.shippingBlock.removeAttribute('hidden');

      if (this.shippingProgress) {
        this.shippingProgress.style.width = Math.min(progress, 100) + '%';
      }

      if (this.shippingText && theme.strings) {
        if (remaining > 0) {
          var amount = theme.Currency.formatMoney(remaining, theme.settings.moneyFormat);
          this.shippingText.innerHTML = theme.strings.ooFreeShippingRemaining.replace('{{ amount }}', amount).replace('[amount]', amount);
        } else {
          this.shippingText.textContent = theme.strings.ooFreeShippingUnlocked;
        }
      }
    };

    OoCartDrawer.prototype.updateShippingBarFromTotals = function(cartTotal, itemCount) {
      var threshold = parseInt(this.form.dataset.freeShippingThreshold, 10) || 0;
      if (threshold <= 0) return;

      var remaining = Math.max(0, threshold - cartTotal);
      var progress = Math.min(100, Math.round(cartTotal * 100 / threshold));
      var shippingData = document.createElement('div');
      shippingData.dataset.count = itemCount;
      shippingData.dataset.freeShippingRemaining = remaining;
      shippingData.dataset.freeShippingProgress = progress;
      this.updateShippingBar(shippingData);
    };

    OoCartDrawer.prototype.getCartItemsContainer = function() {
      return this.productsContainer && this.productsContainer.querySelector('.cart__items');
    };

    OoCartDrawer.prototype.findCartItemRow = function(item, usedRows) {
      if (!item) return null;

      usedRows = usedRows || [];
      var row = this.form.querySelector('.oo-cart-item[data-key="' + item.key + '"]');

      if (row && usedRows.indexOf(row) === -1) {
        return row;
      }

      var candidates = this.form.querySelectorAll('.oo-cart-item[data-variant-id="' + item.variant_id + '"]');

      for (var i = 0; i < candidates.length; i++) {
        if (usedRows.indexOf(candidates[i]) === -1) {
          return candidates[i];
        }
      }

      return null;
    };

    OoCartDrawer.prototype.syncCartItemRowIdentity = function(row, item) {
      if (!row || !item || row.dataset.key === item.key) return;

      row.dataset.key = item.key;

      var input = row.querySelector('.js-qty__num');
      if (input) {
        input.dataset.id = item.key;
        input.id = 'oo_cart_updates_' + item.key;
      }

      var removeBtn = row.querySelector('.js-oo-cart-remove');
      if (removeBtn) {
        removeBtn.dataset.id = item.key;
      }
    };

    OoCartDrawer.prototype.needsProductMarkupRefresh = function(cart) {
      if (!cart || !cart.items || !cart.items.length) return false;
      if (!this.getCartItemsContainer()) return true;

      var usedRows = [];

      for (var i = 0; i < cart.items.length; i++) {
        var matchedRow = this.findCartItemRow(cart.items[i], usedRows);
        if (!matchedRow) return true;
        usedRows.push(matchedRow);
      }

      if (this.upsellContainer && !this.upsellContainer.querySelector('[data-oo-upsell]')) {
        return true;
      }

      return false;
    };

    OoCartDrawer.prototype.refreshUpsellFromAjax = function() {
      if (!this.upsellContainer) return Promise.resolve();

      var url = theme.routes.cartPage + '?view=oo-ajax&t=' + Date.now();

      return fetch(url, { credentials: 'same-origin', method: 'GET' })
        .then(function(response) { return response.text(); })
        .then(function(text) {
          var html = document.createElement('div');
          html.innerHTML = text;
          this.updateUpsell(html.querySelector('[data-oo-upsell]'));
        }.bind(this))
        .catch(function(e) { console.error(e); });
    };

    OoCartDrawer.prototype.refreshProductMarkup = function() {
      var url = theme.routes.cartPage + '?view=oo-ajax&t=' + Date.now();

      return fetch(url, { credentials: 'same-origin', method: 'GET' })
        .then(function(response) { return response.text(); })
        .then(function(text) {
          var html = document.createElement('div');
          html.innerHTML = text;
          var items = html.querySelector('.cart__items');
          var upsell = html.querySelector('[data-oo-upsell]');
          var discounts = html.querySelector('.cart__discounts');

          if (items && this.productsContainer) {
            this.productsContainer.innerHTML = '';
            this.productsContainer.appendChild(items);
          }

          this.cartForm.updateCartDiscounts(discounts);
          this.updateUpsell(upsell);

          if (items) {
            this.updateShippingBar(items);
            var subtotal = items.dataset.cartSubtotal;
            var originalSubtotal = items.dataset.cartOriginalSubtotal;
            if (this.cartForm.subtotal) {
              this.cartForm.subtotal.innerHTML = theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);
            }
            this.updateSubtotalDisplay(subtotal, originalSubtotal);
            this.updateEmptyState(parseInt(items.dataset.count, 10) || 0);
            this.cartForm.updateCount(parseInt(items.dataset.count, 10) || 0);
          }

          if (this.cartForm.reInit) {
            this.cartForm.reInit();
          }
        }.bind(this))
        .catch(function(e) { console.error(e); });
    };

    OoCartDrawer.prototype.handleCartAdded = function() {
      var self = this;

      if (self.body && self.body.classList.contains('is-empty')) {
        self.updateEmptyState(1);
      }

      return theme.cart.getCart()
        .then(function(cart) {
          self.applyCartJson(cart);

          var refresh = self.needsProductMarkupRefresh(cart)
            ? self.refreshProductMarkup()
            : Promise.resolve();

          return refresh.then(function() {
            document.dispatchEvent(new CustomEvent('cart:updated', {
              detail: { cart: cart }
            }));
          });
        })
        .catch(function(e) { console.error(e); });
    };

    OoCartDrawer.prototype.updateUpsell = function(upsell) {
      if (!this.upsellContainer) return;
      this.upsellContainer.innerHTML = '';
      if (upsell) {
        this.upsellContainer.appendChild(upsell);
        this.initUpsellControls();
      }
    };

    OoCartDrawer.prototype.updateUpsellArrows = function(track) {
      if (!track) return;

      var upsell = track.closest('[data-oo-upsell]');
      if (!upsell) return;

      var prevBtn = upsell.querySelector('.js-oo-upsell-prev');
      var nextBtn = upsell.querySelector('.js-oo-upsell-next');
      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      var canScroll = maxScroll > 2;

      if (prevBtn) {
        prevBtn.disabled = !canScroll || track.scrollLeft <= 2;
      }
      if (nextBtn) {
        nextBtn.disabled = !canScroll || track.scrollLeft >= maxScroll - 2;
      }
    };

    OoCartDrawer.prototype.refreshUpsellArrowStates = function() {
      if (!this.upsellContainer) return;

      var self = this;
      this.upsellContainer.querySelectorAll('.js-oo-upsell-track').forEach(function(track) {
        self.updateUpsellArrows(track);
      });
    };

    OoCartDrawer.prototype.scheduleUpsellArrowRefresh = function() {
      var self = this;

      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          self.refreshUpsellArrowStates();
        });
      });

      setTimeout(function() {
        self.refreshUpsellArrowStates();
      }, 350);
    };

    OoCartDrawer.prototype.scrollUpsellTrack = function(button, forward) {
      var upsell = button.closest('[data-oo-upsell]');
      var track = upsell && upsell.querySelector('.js-oo-upsell-track');
      if (!track) return;

      var direction = forward ? 1 : -1;
      track.scrollBy({ left: direction * track.clientWidth * 0.85, behavior: 'smooth' });

      var self = this;
      setTimeout(function() {
        self.updateUpsellArrows(track);
      }, 350);
    };

    OoCartDrawer.prototype.initUpsellControls = function() {
      if (!this.upsellContainer) return;

      var self = this;

      if (typeof ResizeObserver !== 'undefined') {
        if (!this._upsellResizeObserver) {
          this._upsellResizeObserver = new ResizeObserver(function(entries) {
            entries.forEach(function(entry) {
              self.updateUpsellArrows(entry.target);
            });
          });
        }

        this.upsellContainer.querySelectorAll('.js-oo-upsell-track').forEach(function(track) {
          if (!track.dataset.ooResizeObserved) {
            track.dataset.ooResizeObserved = 'true';
            self._upsellResizeObserver.observe(track);
          }
          self.updateUpsellArrows(track);
        });
      } else {
        this.refreshUpsellArrowStates();
      }

      this.upsellContainer.querySelectorAll('.js-oo-upsell-variant').forEach(function(select) {
        self.syncUpsellVariant(select);
      });
    };

    OoCartDrawer.prototype.syncUpsellVariant = function(select) {
      if (!select) return;

      var card = select.closest('.oo-cart-upsell__card');
      if (!card) return;

      var option = select.options[select.selectedIndex];
      var variantId = select.value;
      var price = option && option.dataset.price;
      var addBtn = card.querySelector('.js-oo-upsell-add');
      var priceEl = card.querySelector('[data-oo-upsell-price]');

      if (addBtn) {
        addBtn.dataset.variantId = variantId;
      }

      if (priceEl && price && theme.Currency) {
        priceEl.textContent = theme.Currency.formatMoney(parseInt(price, 10), theme.settings.moneyFormat);
      }
    };

    OoCartDrawer.prototype.updateSubtotalDisplay = function(subtotal, originalSubtotal) {
      if (!this.subtotalOriginal) {
        this.subtotalOriginal = this.form && this.form.querySelector('[data-oo-subtotal-original]');
      }
      if (!this.subtotalOriginal) return;

      subtotal = parseInt(subtotal, 10) || 0;
      originalSubtotal = parseInt(originalSubtotal, 10) || 0;

      var itemsContainer = this.getCartItemsContainer();
      var originalFromDataset = itemsContainer
        ? parseInt(itemsContainer.dataset.cartOriginalSubtotal, 10) || 0
        : 0;
      var originalFromDom = getStrikethroughSubtotalFromDom(this.form);

      originalSubtotal = Math.max(originalSubtotal, originalFromDataset, originalFromDom);

      if (originalSubtotal > subtotal) {
        this.subtotalOriginal.classList.remove('hide');
        this.subtotalOriginal.textContent = theme.Currency.formatMoney(originalSubtotal, theme.settings.moneyFormat);
      } else {
        this.subtotalOriginal.classList.add('hide');
      }
    };

    OoCartDrawer.prototype.updateEmptyState = function(count) {
      if (this.body) {
        this.body.classList.toggle('is-empty', count === 0);
      }
      if (this.footer) {
        if (count === 0) {
          this.footer.setAttribute('hidden', '');
        } else {
          this.footer.removeAttribute('hidden');
        }
      }
      if (this.emptyState) {
        this.emptyState.classList.toggle('hide', count > 0);
      }
    };

    OoCartDrawer.prototype.bindEvents = function() {
      var self = this;

      document.addEventListener('ajaxProduct:added', function() {
        self.open();
        self.handleCartAdded();
      });

      document.addEventListener('cart:build', function() {
        if (!theme.ooCartDrawer) return;
        clearTimeout(self._cartBuildTimer);
        self._cartBuildTimer = setTimeout(function() {
          self.cartForm.buildCart();
        }, 150);
      });

      document.addEventListener('cart:open', function() {
        self.open();
      });

      document.addEventListener('drawerOpen.OoCartDrawer', function() {
        self.scheduleUpsellArrowRefresh();
        var itemsContainer = self.getCartItemsContainer();
        var subtotal = itemsContainer ? parseInt(itemsContainer.dataset.cartSubtotal, 10) : 0;
        var originalSubtotal = itemsContainer ? parseInt(itemsContainer.dataset.cartOriginalSubtotal, 10) : 0;
        self.updateSubtotalDisplay(subtotal || 0, originalSubtotal || 0);
      });

      document.addEventListener('cart:close', function() {
        self.drawer.close();
      });

      this.form.addEventListener('click', function(evt) {
        var plusBtn = evt.target.closest('.js-oo-qty-plus');
        var minusBtn = evt.target.closest('.js-oo-qty-minus');

        if (plusBtn || minusBtn) {
          evt.preventDefault();
          evt.stopPropagation();
          self.updateCartItemQuantity(plusBtn || minusBtn, !!plusBtn);
          return;
        }

        var removeBtn = evt.target.closest('.js-oo-cart-remove');
        if (removeBtn) {
          evt.preventDefault();
          evt.stopPropagation();
          self.removeCartItem(removeBtn);
          return;
        }

        var upsellPrev = evt.target.closest('.js-oo-upsell-prev');
        var upsellNext = evt.target.closest('.js-oo-upsell-next');
        if (upsellPrev || upsellNext) {
          evt.preventDefault();
          evt.stopPropagation();
          self.scrollUpsellTrack(upsellPrev || upsellNext, !!upsellNext);
          return;
        }

        var upsellBtn = evt.target.closest('.js-oo-upsell-add');
        if (upsellBtn) {
          evt.preventDefault();
          evt.stopPropagation();
          self.addUpsellProduct(upsellBtn);
          return;
        }
      });

      this.form.addEventListener('change', function(evt) {
        var upsellSelect = evt.target.closest('.js-oo-upsell-variant');
        if (!upsellSelect) return;
        evt.stopPropagation();
        self.syncUpsellVariant(upsellSelect);
      });

      if (this.upsellContainer) {
        this.upsellContainer.addEventListener('scroll', function(evt) {
          if (!evt.target.classList.contains('js-oo-upsell-track')) return;
          self.updateUpsellArrows(evt.target);
        }, true);
      }
    };

    OoCartDrawer.prototype.showNotice = function(message) {
      if (!message) return;

      if (!this.noticeEl) {
        alert(message);
        return;
      }

      this.noticeEl.textContent = message;
      this.noticeEl.removeAttribute('hidden');

      clearTimeout(this._noticeTimeout);
      this._noticeTimeout = setTimeout(function() {
        this.noticeEl.setAttribute('hidden', '');
      }.bind(this), 4000);
    };

    OoCartDrawer.prototype.isAtMaxInventory = function(input, qty) {
      var maxQty = parseInt(input.dataset.maxQuantity, 10);
      if (isNaN(maxQty) || maxQty < 0) return false;
      return qty >= maxQty;
    };

    OoCartDrawer.prototype.showMaxInventoryNotice = function() {
      var message = theme.strings && theme.strings.ooMaxInventoryInCart;
      this.showNotice(message || 'Maximum quantity reached.');
    };

    OoCartDrawer.prototype.applyCartJson = function(cart, options) {
      options = options || {};
      if (!cart || typeof cart.item_count === 'undefined') return;

      var self = this;

      if (cart.item_count === 0) {
        if (this.productsContainer) {
          this.productsContainer.innerHTML = '';
        }
        if (this.upsellContainer) {
          this.upsellContainer.innerHTML = '';
        }
        if (this.cartForm.discounts) {
          this.cartForm.discounts.innerHTML = '';
        }
        this.cartForm.updateCount(0);
        if (this.shippingBlock) {
          this.shippingBlock.setAttribute('hidden', '');
        }
        this.updateEmptyState(0);
        this._lastCartJsonApply = Date.now();
        return;
      }

      var matchedRows = [];

      cart.items.forEach(function(item) {
        var row = self.findCartItemRow(item, matchedRows);
        if (!row) return;

        matchedRows.push(row);
        self.syncCartItemRowIdentity(row, item);

        var input = row.querySelector('.js-qty__num');
        if (input) input.value = item.quantity;

        var linePrice = item.final_line_price != null ? item.final_line_price : item.line_price;
        row.dataset.linePriceCents = linePrice;

        var priceEl = row.querySelector('[data-line-price]');
        if (priceEl) {
          priceEl.textContent = theme.Currency.formatMoney(linePrice, theme.settings.moneyFormat);
        }

        var strikethroughUnit = getStrikethroughUnitFromRow(row);
        var originalPriceEl = row.querySelector('[data-line-price-original]');
        if (originalPriceEl) {
          var strikethroughLine = 0;

          if (strikethroughUnit > 0) {
            var strikethroughFromUnit = strikethroughUnit * item.quantity;
            if (strikethroughFromUnit > linePrice) {
              strikethroughLine = strikethroughFromUnit;
            }
          } else if (item.original_line_price > linePrice) {
            strikethroughLine = item.original_line_price;
          } else if (item.line_price > linePrice) {
            strikethroughLine = item.line_price;
          }

          if (strikethroughLine > 0 && item.quantity > 0) {
            row.dataset.strikethroughLineCents = strikethroughLine;
            row.dataset.strikethroughUnitCents = Math.round(strikethroughLine / item.quantity);
            originalPriceEl.textContent = theme.Currency.formatMoney(strikethroughLine, theme.settings.moneyFormat);
            originalPriceEl.removeAttribute('hidden');
          } else {
            delete row.dataset.strikethroughLineCents;
            delete row.dataset.strikethroughUnitCents;
            originalPriceEl.textContent = '';
            originalPriceEl.setAttribute('hidden', '');
          }
        }
      });

      this.form.querySelectorAll('.oo-cart-item[data-key]').forEach(function(row) {
        if (matchedRows.indexOf(row) !== -1) return;
        row.remove();
      });

      var itemsContainer = this.productsContainer && this.productsContainer.querySelector('.cart__items');
      var originalSubtotal = getStrikethroughSubtotal(cart, function(item, usedRows) {
        return self.findCartItemRow(item, usedRows);
      });

      if (itemsContainer) {
        itemsContainer.dataset.count = cart.item_count;
        itemsContainer.dataset.cartSubtotal = cart.total_price;
        itemsContainer.dataset.cartOriginalSubtotal = originalSubtotal;
      }

      this.cartForm.updateCount(cart.item_count);

      this.updateShippingBarFromTotals(cart.total_price, cart.item_count);

      if (this.cartForm.subtotal) {
        this.cartForm.subtotal.textContent = theme.Currency.formatMoney(cart.total_price, theme.settings.moneyFormat);
      }

      this.updateSubtotalDisplay(cart.total_price, originalSubtotal);
      this.updateEmptyState(cart.item_count);

      if (options.fullRebuild) {
        this.cartForm.buildCart();
      }

      this._lastCartJsonApply = Date.now();
    };

    OoCartDrawer.prototype.refreshCartFromJson = function() {
      if (Date.now() - this._lastCartJsonApply < 500) return Promise.resolve();

      return theme.cart.getCart()
        .then(this.applyCartJson.bind(this))
        .catch(function(e) { console.error(e); });
    };

    OoCartDrawer.prototype.updateCartItemQuantity = function(button, increment) {
      var wrapper = button.closest('.oo-cart-item__qty');
      if (!wrapper) return;

      var input = wrapper.querySelector('.js-qty__num');
      if (!input) return;

      var key = input.dataset.id;
      if (!key) return;

      var qty = parseInt(input.value, 10) || 1;
      var newQty = increment ? qty + 1 : qty - 1;

      if (newQty < 0) newQty = 0;

      if (increment && this.isAtMaxInventory(input, qty)) {
        this.showMaxInventoryNotice();
        return;
      }

      var previousQty = qty;
      input.value = newQty;
      wrapper.classList.add('is-loading');

      theme.cart.changeItem(key, newQty)
        .then(function(cart) {
          wrapper.classList.remove('is-loading');
          var parsedCart = JSON.parse(cart);

          if (parsedCart.status === 422) {
            input.value = previousQty;
            this.showMaxInventoryNotice();
            return;
          }

          this.applyCartJson(parsedCart);

          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { cart: parsedCart }
          }));
        }.bind(this))
        .catch(function() {
          wrapper.classList.remove('is-loading');
          input.value = previousQty;
        });
    };

    OoCartDrawer.prototype.removeCartItem = function(button) {
      var key = button.dataset.id;
      if (!key) return;

      var row = button.closest('.oo-cart-item');
      var itemsContainer = this.getCartItemsContainer();
      var optimisticSubtotal = null;
      var optimisticCount = null;

      if (row && itemsContainer) {
        var input = row.querySelector('.js-qty__num');
        var qty = input ? parseInt(input.value, 10) || 1 : 1;
        var linePrice = parseInt(row.dataset.linePriceCents, 10) || 0;
        var currentSubtotal = parseInt(itemsContainer.dataset.cartSubtotal, 10) || 0;
        var currentCount = parseInt(itemsContainer.dataset.count, 10) || 0;

        optimisticSubtotal = Math.max(0, currentSubtotal - linePrice);
        optimisticCount = Math.max(0, currentCount - qty);

        itemsContainer.dataset.cartSubtotal = optimisticSubtotal;
        itemsContainer.dataset.count = optimisticCount;

        if (this.cartForm.subtotal) {
          this.cartForm.subtotal.textContent = theme.Currency.formatMoney(optimisticSubtotal, theme.settings.moneyFormat);
        }

        this.cartForm.updateCount(optimisticCount);
        this.updateShippingBarFromTotals(optimisticSubtotal, optimisticCount);

        if (optimisticCount === 0) {
          this.updateEmptyState(0);
        }

        row.classList.add('is-loading');
        row.remove();
      } else if (row) {
        row.classList.add('is-loading');
        row.remove();
      } else {
        button.classList.add('is-loading');
      }

      theme.cart.changeItem(key, 0)
        .then(function(cart) {
          var parsedCart = JSON.parse(cart);

          if (parsedCart.status === 422) {
            this.cartForm.buildCart();
            alert(parsedCart.message);
            return;
          }

          this.applyCartJson(parsedCart);
          if (parsedCart.item_count > 0) {
            this.refreshUpsellFromAjax();
          }
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { cart: parsedCart }
          }));
        }.bind(this))
        .catch(function() {
          this.cartForm.buildCart();
        }.bind(this));
    };

    OoCartDrawer.prototype.addUpsellProduct = function(button) {
      var card = button.closest('.oo-cart-upsell__card');
      var select = card && card.querySelector('.js-oo-upsell-variant');
      var variantId = (select && select.value) || button.dataset.variantId;
      if (!variantId) return;

      button.classList.add('is-loading');

      fetch(theme.routes.cartAdd, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      })
        .then(function(response) { return response.json(); })
        .then(function(data) {
          button.classList.remove('is-loading');
          if (data.status === 422) {
            alert(data.message || data.description);
            return;
          }
          this.handleCartAdded();
        }.bind(this))
        .catch(function() {
          button.classList.remove('is-loading');
        });
    };

    OoCartDrawer.prototype.open = function() {
      this.drawer.open();
      theme.a11y.trapFocus({
        container: this.form,
        elementToFocus: this.form,
        namespace: 'oocartdrawer_focus'
      });
      this.scheduleUpsellArrowRefresh();
    };

    OoCartDrawer.prototype.close = function() {
      this.drawer.close();
      theme.a11y.removeTrapFocus({
        container: this.form,
        namespace: 'oocartdrawer_focus'
      });
    };

    return OoCartDrawer;
  })();

  function shouldUseOoCartDrawer() {
    if (theme.settings.cartType !== 'drawer') return false;
    if (theme.settings.useOoCartDrawer === false) return false;
    return !!document.getElementById('OoCartDrawer');
  }

  function initOoCartDrawer() {
    if (!shouldUseOoCartDrawer() || theme.ooCartDrawer) return;
    theme.ooCartDrawer = new theme.OoCartDrawer();
  }

  document.addEventListener('page:loaded', initOoCartDrawer);

  // oo-cart-drawer.js loads after theme.js, so page:loaded may already have fired
  if (document.readyState !== 'loading') {
    initOoCartDrawer();
  } else {
    document.addEventListener('DOMContentLoaded', initOoCartDrawer);
  }
})();
